// Deterministic placeholder avatar generated from a seed (user id / name),
// so the same user always renders the same illustrated avatar.
export const getAvatarUrl = (seed?: string) =>
  `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(
    seed || "user"
  )}`;
